<template>
  <div class="row">
    <div class="col-md-8 col-sm-12 mt-2">
      <h4 class="d-inline">{{ $t('Latest news') }}</h4>
    </div>
    <div class="col-md-4 col-sm-12 pb-3" style="margin-top: -5px;">
      <div class="pull-right btn-one-size-custom">
        <router-link :to="{ name: 'News' }">
          <p-button round class="btn-outline-primary btn-one-size btn-one-size-custom">{{ $t('All news') }}</p-button>
        </router-link>
      </div>
    </div>
    <div class="col-xl-3 col-sm-6" v-for="newsList in news.items">
      <news-box :news="newsList"/>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import NewsBox from 'src/components/Dashboard/Components/NewsBox'
  import PButton from '../../UIComponents/Button'

  export default {
    name: 'News',
    components: {
      PButton,
      NewsBox
    },
    data () {
      return {}
    },
    mounted () {
      this.init()
    },
    computed: {
      ...mapState('news', {
        news: state => state.dashboardItems
      })
    },
    methods: {
      ...mapActions('news', [
          'getDashboardNews'
        ]
      ),

      init () {
        this.getDashboardNews({ limit: 4 })
      }
    }
  }
</script>

<style lang="scss" scoped>
    @media (max-width: 590px) {
      .btn-one-size-custom {
        width: 100%;
        padding-left: 0px;
        padding-right: 0px;
        padding-top: 10px;
        margin-right: 5px;
      }
    }
</style>